import { Styles } from 'assets/types';
import globalLabelsCellStyles from 'assets/stylesheets/defaultStyles/labelsCell.style';

const tagsCellStyles: Styles = theme => ({
  ...globalLabelsCellStyles(theme),
});

export default tagsCellStyles;
